import { computed, Component } from 'vue';
import { IRouter, Routes, TRoutes } from '@/models/router/router.interface';
import { ModalErrorState, ModalErrorStateType } from '@/models/modal.interface';
import initialRoutePresenter from '@/presenters/initial-route-presenter';
import dashboardsPresenter from '@/presenters/dashboards-presenter';
import Overview from '@/presentation/pages/overview/overview.vue';
import SelectedDashboard from '@/presentation/pages/selected-dashboard/selected-dashboard.vue';
import DataTracker from '@/infrastructure/data-tracker';
import tableauJWTPresenter from '@/presenters/tableau-jwt-presenter';
import store from '@/store';

export default class AppCode {
	private routes: TRoutes = {
		[Routes.OVERVIEW]: Overview,
		[Routes.SELECTED_DASHBOARD]: SelectedDashboard
	};

	// eslint-disable-next-line @typescript-eslint/naming-convention
	public CurrentComponent = computed((): Component => {
		return this.routes[this.router.value.current];
	});

	public router = computed((): IRouter => {
		return store.getters.router();
	});

	public isErrorActive = computed((): boolean => {
		return this.modalErrorState.value !== ModalErrorState.INACTIVE;
	});

	private modalErrorState = computed((): ModalErrorStateType => {
		return store.getters.modalErrorState();
	});

	private tracker = computed((): DataTracker => {
		return store.getters.tracker();
	});

	public async mounted(): Promise<void> {
		this.tracker.value.trackLoadingSpeed(false);

		initialRoutePresenter.prepareForRoutingActions();
		await tableauJWTPresenter.startTableauJWTFetchLoop();
		await dashboardsPresenter.retrieveAvailableDashboards();

		this.tracker.value.trackUserDetailsActiveDashboardsCount();
		this.tracker.value.trackLoadingSpeed(true);
	}

	public unmounted(): void {
		tableauJWTPresenter.stopTableauJWTFetchLoop();
	}
}
